// extracted by mini-css-extract-plugin
export default {"selected_row":"styles_selected_row__27opa"};